<template>
  <div id="uyh-nav" :class="{mobile: windowWidth <= 1199 && landingRoute}">

    <!-- Link wrappers -->
    <ul v-if="windowWidth > 1199">
      <li><router-link to="/" :class="{active: isLanding}">{{ $t('navigation.get_started') }}</router-link></li>
      <li><router-link to="/pick-a-mantra" :class="{active: isMantra}">{{ $t('navigation.pick_mantra') }}</router-link></li>
      <li><router-link to="/share" :class="{active: isShare}">{{ $t('navigation.send_message') }}</router-link></li>
    </ul>

    <div v-if="windowWidth <= 1199" class="uyh-mobile-nav-links">
      <ul class="links-wrapper">
        <li><router-link to="/" :class="{active: isLanding}">{{ $t('navigation.get_started') }}</router-link></li>
        <li><router-link to="/pick-a-mantra" :class="{active: isMantra}">{{ $t('navigation.pick_mantra') }}</router-link></li>
        <li><router-link to="/share" :class="{active: isShare}">{{ $t('navigation.send_message') }}</router-link></li>
      </ul>
    </div>

    <!-- Language wrapper -->
    <div class="select-wrapper" @click="langOpen = !langOpen">
      <div id="uyh-locale-visible">
        <div class="option-value">{{ $t(getLanguage()) }}</div>
        <svg svg-inline="" class="down" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg>

        <transition name="fade-down">
          <div class="option-wrapper" v-if="langOpen">
            <p value='en' :class="{ active: locale == 'en'}" @click="changeLang('en')">{{ $t('languages.en') }}</p>
            <p value='es' :class="{ active: locale == 'es'}" @click="changeLang('es')">{{ $t('languages.es') }}</p>
            <p value='de' :class="{ active: locale == 'de'}" @click="changeLang('de')">{{ $t('languages.de') }}</p>
            <p value='ar' :class="{ active: locale == 'ar'}" @click="changeLang('ar')">{{ $t('languages.ar') }}</p>
            <p value='jp' :class="{ active: locale == 'jp'}" @click="changeLang('jp')">{{ $t('languages.jp') }}</p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import getCookie from '@/assets/javascripts/get_cookie'

  export default {
    name: 'language_switch',
    data () {
      return {
        isLanding: false,
        isMantra: false,
        isShare: false,
        windowWidth: 0,
        locale: this.$i18n.locale,
        langOpen: false,
        linksOpen: false,
        landingRoute: false,
        activeLink: this.$t('navigation.send_message')
      }
    },
    methods: {
      widowWidth: function() {
        this.windowWidth = window.innerWidth;
      },
      changeLang: function(value) {
        let fromLocale = getCookie('lang');
        let toLocale = value;
        this.$i18n.locale = toLocale;
        this.locale = toLocale;
        document.cookie = "lang=" + toLocale;
        this.$store.dispatch('updateLocale', {
          locale: toLocale
        });
        window.dataLayer.push({
          'event': 'locale-switch',
          'url': window.location.href,
          'fromLocale': fromLocale,
          'toLocale': toLocale
        });
      },
      checkLang: function() {
        var cookiedLang = this.getCookie('lang');
        this.changeLang(cookiedLang);
      },
      getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },
      getLanguage: function() {
        return 'languages.' + this.locale;
      },
      getLink: function() {
        return 'navigation.' + this.activeLink;
      },
      updateActiveLink: function(value) {
        this.activeLink = value;
      },
      activeStates: function() {
        if (this.$route.path === '/' || this.$route.path === '/learn-how' || this.$route.path === '/get-started') {
          this.isLanding = true;
          this.isMantra = false;
          this.isShare = false;
        } else if (this.$route.path === '/pick-a-mantra' || this.$route.path.includes('/send-message/') ) {
          this.isLanding = false;
          this.isMantra = true;
          this.isShare = false;
        } else if (this.$route.path === '/share') {
          this.isLanding = false;
          this.isMantra = false;
          this.isShare = true;
        }
      }
    },
    mounted: function() {
      this.$nextTick(function() {
        window.addEventListener('resize', this.widowWidth);
        this.widowWidth();
        this.checkLang();
        this.activeStates();
      });
    },
    watch: {
      $route: function() {
        if (this.$route.path === '/') {
          this.landingRoute = true;
        } else {
          this.landingRoute = false;
        }

        this.activeStates();
      }
    },
    destroyed: function() {
      document.removeEventListener('resize', this.widowWidth);
    }
  }
</script>

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    #uyh-nav {
      background: #22372b;
      padding: 19px 10px 21px;
      position: relative;
      z-index: 10;
      @media screen and (max-width: 1199px) {
        z-index: 1;
      }

      // Nav links
      ul {
        display: flex;
        flex-direction: row;
        height: 20px;
        justify-content: center;
        list-style: none;
        overflow: hidden;
        margin: 0 auto;
        padding: 0;
        li {
          flex: 0 1 auto;
          font-size: 15px;
          margin: 0 63.5px;
          a {
            color: #f8baca;
            letter-spacing: 0.8px;
            opacity: 0.5;
            pointer-events: none;
            text-decoration: none;
            &.active {
              color: #f8baca;
              opacity: 1;
              &:after {
                display: none;
              }
            }
          }
        }
      }

      .select-wrapper {
        align-items: center;
        display: flex;
        flex-wrap: nowrap;
        position: absolute;
        right: 5.2%;
        top: 50%;
        transform: translateY(-50%);

        #uyh-locale {
          display: none;
        }
        #uyh-locale-visible {
          background-color: transparent;
          border: none;
          color: #f8baca;
          cursor: pointer;
          font-family: 'FuturaPTMedium';
          font-size: 15px;
          height: initial;
          position: relative;
          width: initial;
          .option-value {
            display: inline-block;
          }
          .down {
            cursor: pointer;
            height: 9px;
            left: 0;
            position: relative;
            transform: rotate(-90deg);
            path {
              fill: #f8baca;
            }
          }

          .option-wrapper {
            background-color: #FBEAEF;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
            opacity: 1;
            position: absolute;
            right: 0;
            top: calc(100% + 10px);
            p {
              color: #22372b;
              cursor: pointer;
              margin: 0;
              padding: 1rem 2rem;
              &:hover,
              &.active {
                background-color: #22372b;
                color: #f8baca;
              }
            }
          }

          .fade-down-enter-active, .fade-down-leave-active {
            transition: top 0.3s ease-in-out, opacity 0.18s ease-in-out;
          }
          .fade-down-leave,
          .fade-down-leave-to,
          .fade-down-enter {
            opacity: 0;
            top: calc(100% - 15px);
          }
        }
      }
    }


    #uyh-nav {
      @media screen and (max-width: 1300px) {
        padding: 10px 0;
      }

      @media screen and (max-width: 1199px) {
        padding: 0;
        .select-wrapper {
          display: none;
        }
      }

      .uyh-mobile-nav-links {
        cursor: pointer;
        * {
          color: #fbeaef;
          fill: #fbeaef;
        }

        .links-wrapper {
          display: block;
          height: 45px;
          position: relative;
          li {
            left: 50%;
            margin: 0 auto;
            position: absolute;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            list-style: none;
            a {
              visibility: hidden;
              &.active {
                visibility: visible;
              }
            }
          }
        }
      }

      &.mobile {
        padding: 0;
        .select-wrapper {
          background-color: #fbeaef;
          border: 1px solid #223628;
          display: block;
          position: relative;
          right: 0;
          top: 0;
          transform: none;
          #uyh-locale-visible {
            .option-value {
              color: #223628;
              font-size: 14px;
              font-weight: 500;
              letter-spacing: 0.7px;
              padding: 8px 0 9px;
            }
            .down {
              path {
                fill: #223628;
              }
            }

            .option-wrapper {
              top: 100%;
              width: 100%;
              p {
                &:hover {
                  background-color: transparent;
                  color: #22372b;
                  &.active {
                    background-color: #22372b;
                    color: #f8baca;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
